import cls from 'classnames';
import { useEffect } from 'react';
import toast, { resolveValue, Toast, Toaster } from 'react-hot-toast';

import styles from './index.module.scss';
import closeIcon from '../../../assets/Edit/close.png';
import { LocalImage } from '../../Image';

function ToastContent({ t }: { t: Toast }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      toast.remove(t.id);
    }, 3000);
    return () => clearTimeout(timer);
  }, [t.id]);

  return (
    <div
      className={cls(styles.toast, {
        [styles.success]: t.type === 'success',
        [styles.error]: t.type === 'error',
        [styles.info]: t.type === 'blank',
      })}
    >
      <div className={styles.icon} />
      <div className={styles.content}>{resolveValue(t.message, t)}</div>
      <div className={styles.close} onClick={() => toast.dismiss(t.id)}>
        <LocalImage src={closeIcon} />
      </div>
    </div>
  );
}

export function UniToast() {
  return <Toaster>{(t) => <ToastContent t={t} />}</Toaster>;
}
